import "./Count.css";
import { ReactComponent as PlusIcon } from "../../assets/icons/plus.svg";
import { ReactComponent as MinusIcon } from "../../assets/icons/minus.svg";
import { connect } from "react-redux";
import {
  cartItem,
  extrasCartItem,
  Item
} from "../../state_management/reducers/cart";
import { changeCartItem } from "../../state_management/actions";
import { extra_service_ext, service } from "../../state_management/actionTypes";
import { useInCart } from "../../utilities/cart";
import { useEffect, useState } from "react";
import { stateType } from "../../store";
import { isNumber } from "../../utilities/misc";

type defaultProps = {
  cart: cartItem[];
  extras: extrasCartItem[];
  allowPropagation?: boolean;
  changeCartItem: (data: Item) => void;
  extraService?: boolean;
  service: service | extra_service_ext;
  max?: number;
  invisible?: boolean;
};

const Count = ({
  cart,
  extras,
  service,
  changeCartItem,
  allowPropagation,
  max,
  fromZero,
  extraService,
  extCount,
  extSetCount,
  invisible
}: defaultProps &
  (
    | {
        extCount: number;
        extSetCount: (data: number) => void;
        fromZero?: never;
      }
    | {
        extCount?: never;
        extSetCount?: never;
        fromZero: boolean;
      }
  )) => {
  const floorValue = fromZero ? 0 : 1;
  const Cart = extraService ? extras : cart;
  const cart_item = useInCart(service.id, Cart);
  const [count, setCount] = useState(cart_item?.quantity || floorValue);
  const Count = isNumber(extCount) ? extCount! : count;
  const SetCount = invisible
    ? (data: number) => {}
    : extSetCount
    ? extSetCount
    : setCount;

  const change = (count: number) => {
    if (invisible) {
      return;
    }
    const item_service = cart_item?.item || service;
    const item = extraService
      ? ({
          id: service.id,
          quantity: count,
          item: { ...item_service, extra: true },
          parent_id: service.parent_id,
          type: "extra"
        } as extrasCartItem)
      : ({
          id: service.id,
          quantity: count,
          item: { ...item_service, extra: false },
          type: (service as service).type
        } as cartItem);

    changeCartItem(item);
  };

  useEffect(() => {
    SetCount(cart_item?.quantity || floorValue);
  }, [cart_item?.quantity, cart.length, floorValue]);

  const normalize = (count: number) => {
    if (count <= floorValue) {
      return floorValue;
    } else {
      return count;
    }
  };

  const removeActive = !!(cart_item && cart_item.quantity > floorValue);
  const reduceable = Count > floorValue;
  const disabledReduce = !fromZero ? !reduceable : !removeActive;

  const Max = (() => {
    const maxNum = parseInt(`${max}`);
    return typeof maxNum === "number" && !isNaN(maxNum) ? maxNum : Infinity;
  })();

  const maxOut = (value: number) => {
    if (value > Max) {
      return Max;
    } else {
      return value;
    }
  };

  const addActive = (count = Count, noEquals?: boolean) =>
    (noEquals ? count > Max : count >= Max)
      ? false
      : fromZero
      ? true
      : !!cart_item;
  const disableAdd = !fromZero && Count < Max ? false : !addActive();

  return (
    <div className={`count_wrapper flex ${invisible ? "invisibleCount" : ""}`}>
      <div
        onClick={(e) => {
          if (!allowPropagation) {
            e.stopPropagation();
          }
          const newCount = normalize(Count - 1);
          if (reduceable) {
            if (!fromZero) {
              SetCount(newCount);
            } else if (fromZero && removeActive) {
              SetCount(newCount);
            }
            if (removeActive) {
              change(newCount);
            }
          }
        }}
        aria-disabled={disabledReduce}
        className="cell center"
      >
        <div className="pressBtn center">
          <MinusIcon className="img_div_contain center" />
        </div>
      </div>
      <input
        type="number"
        // readOnly={disableAdd}
        value={Count}
        onChange={(e) => {
          const value = e.target.value;
          const count = parseInt(value || `${floorValue}`);
          if ((!fromZero ? count : true) && /^\d*$/.test(`${count}`)) {
            const maxOutVal = maxOut(count);
            const localActive = addActive(maxOutVal, true);
            if (!fromZero) {
              SetCount(normalize(maxOutVal));
            } else if (fromZero && localActive) {
              SetCount(normalize(maxOutVal));
            }
            if (localActive) {
              change(maxOutVal);
            }
          }
        }}
        className="cell center"
      />
      <div
        onClick={(e) => {
          if (!allowPropagation) {
            e.stopPropagation();
          }
          const newCount = normalize(Count + 1);
          const localActive = addActive();
          if (!fromZero) {
            SetCount(maxOut(newCount));
          } else if (fromZero && localActive) {
            if (localActive) {
              SetCount(maxOut(newCount));
            }
          }
          if (localActive) {
            change(maxOut(newCount));
          }
        }}
        aria-disabled={disableAdd}
        className="cell center"
      >
        <div className="pressBtn center">
          <PlusIcon className="img_div_contain center" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras
});

const mapDispatchToProps = (dispatch: any) => ({
  changeCartItem: (data: Item) => {
    dispatch(changeCartItem(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Count);
